<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-11 16:27:56
 * @LastEditTime: 2019-08-12 16:19:49
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="m_head_banner">
    <!-- 预留位置放置导航组件 navigator -->
    <img
      class="banner_img"
      :src="imgUrl"
      alt
    />
    <div class="banner_title_1 left title">
        <slot name="title_1_left"></slot>
    </div>
    <div class="banner_title_2 left  title">
        <slot name="title_2_left"></slot>
    </div>
    <div class="banner_title_1 center title" >
        <slot name="title_1_center"></slot>
    </div>
    <div class="banner_title_2 center title">
        <slot name="title_2_center"></slot>
    </div>
    <!-- 默认插槽 -->
    <slot></slot>
  </div>
</template>

<script>
// import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
export default {
  // mixins: [mixinName],
  // components: {},
  props: {
    imgUrl: {
      type: String,
      default: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/about_us.png'
    }
  },
  data () {
    return {
      key: 'value'
    }
  },
  created () {},
  methods: {},
  computed: {
    name () {
      return this.key
    }
  }
}
</script>

<style scoped lang="scss">
.m_head_banner {
  position: relative;
  color: #ffffff;
  // margin-top: rem(55);
  .banner_img {
    width: 100%;
    height: rem(525);
  }
  .title {
    position: absolute;
    line-height:rem(58);
  }
  .left{
    left:rem(41);
    text-align: left;
  }
  .center{
      @include cl;
  }
  .banner_title_1 {
    font-size: rem(42);
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: rem(53);
    top:rem(211);
  }
  .banner_title_2 {
    font-size: rem(42);
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: rem(58);
    top:rem(270);
    width: rem(412)
    }
}
</style>
